import * as BaseApi from "api/Base.api";

const BASE_URL = "/koach";

export const getInfoForKoach = async () => {
    const url = `${BASE_URL}/info/koach`;
    return await BaseApi.get(url);
};